import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

import { PopupModeService } from 'services/popupModeService';
import { Footer } from '../../index';
import { PricingPageContent } from './PricingPageContent/PricingPageContent';
import { MetaFooter } from '../../MetaFooter';
import { withPromo } from '../../Promo';
import { IframeModeService } from 'services/iframeModeService';

const StyledPricePageWrapper = styled.div`
  overflow: auto;
  height: 100%;
`;

export const PricingPage = withPromo(
  React.memo(({ user, loading }) => {
    const isPopupMode = PopupModeService.isPopupMode();
    const isIframeMode = IframeModeService.isIframeMode();

    if (isPopupMode) {
      return (
        <StyledPricePageWrapper className="App withFooterOverlay">
          <PricingPageContent user={user} loading={loading} />
        </StyledPricePageWrapper>
      );
    }

    if (isIframeMode) {
      return (
        <StyledPricePageWrapper className="App withFooterOverlay">
          <PricingPageContent user={user} loading={loading} />
          <MetaFooter>
            <Footer />
          </MetaFooter>
        </StyledPricePageWrapper>
      );
    }

    return (
      <StyledPricePageWrapper className="App withFooterOverlay">
        <PricingPageContent user={user} loading={loading} />
        <MetaFooter>
          <Footer />
        </MetaFooter>
      </StyledPricePageWrapper>
    );
  }),
);

PricingPage.propTypes = {
  user: PropTypes.object,
  loading: PropTypes.bool,
};

PricingPage.defaultProps = {
  user: null,
  loading: false,
};
